import { StringUnionKeyAsValue } from '../helpers/TypescriptHelpers';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IExplorableItemTypeInfo } from './resourceInfoParts';


/**
 * These are the item types that can be browsed in an Explorer.
 * Includes the "primary" content types (from the exploreContent API) and also non-content
 * entities that can be browsed (e.g. subscriptions, refresh extracts).
 */
export type ExplorableItemType = ExploreContentApi_ContentType
    | 'subscription'
    | 'connection'
    | 'extractTask'
    | 'remoteRefreshSchedule'
    | 'connectedWorkbook'
    | 'flowOutputStepRun'
    | 'backgroundJob'
    | 'metric'
  ;

/**
 * These are the entity types that have their own landing pages ("space page").
 * These content types and explorable items, so their names should match where possible.
 */
export type ContentType = 'project' | 'workbook' | 'view' | 'datasource' | 'flow' | 'dataRole';

export const SpaceTypeValue: StringUnionKeyAsValue<ContentType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  dataRole: 'dataRole',
};

export function isSpaceType(itemType: string): itemType is ContentType {
  return SpaceTypeValue.hasOwnProperty(itemType);
}

export function getKeyForExplorableItem(item: IExplorableItemTypeInfo): string {
  return `${item.contentType}_${item.id}`;
}
